import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShow(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-consent", "rejected");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 sm:p-6 flex justify-center">
      <div className="bg-white border border-gray-200 shadow-2xl rounded-2xl max-w-4xl w-full p-6 sm:p-8 animate-in fade-in slide-in-from-bottom-8 duration-500">
        <div className="flex flex-col sm:flex-row items-start gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h3 className="font-display text-xl font-bold text-gray-900">
                {t("gdpr.cookieTitle")}
              </h3>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              {t("gdpr.cookieText")}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto shrink-0 pt-2 sm:pt-0">
            <button
              onClick={handleReject}
              className="px-6 py-2.5 text-sm font-semibold text-gray-600 hover:text-gray-900 hover:bg-gray-50 border border-gray-200 rounded-xl transition-all"
            >
              {t("gdpr.rejectAll")}
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2.5 text-sm font-semibold text-white bg-gray-900 hover:bg-black rounded-xl shadow-lg hover:shadow-xl transition-all"
            >
              {t("gdpr.acceptAll")}
            </button>
          </div>
        </div>
        <button 
          onClick={() => setShow(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
}
